import './base/';
import './sliders/slider-product';
import './sliders/slider';
import './sliders/slider-logos';
import './sliders/slider-products-resize';
import './sliders/slider-timeline';
import './header/header';
import './cart/qty';
import './cart/cart';
import './product/product';
import './product/product-recommended';
import './ajax/load-more';
import './click-events/btn-toggle';
import './click-events/btn-scroll';
import './click-events/navigation';
import './click-events/accordion';
import './click-events/click-document';
import './click-events/copy-clipboard';
import './popups/popup-image';
import './popups/popup-inline';
import './popups/popup-video';
import './forms/form-validate';
